const data = [
  { id: 1, name: "Recuperação Judicial" },
  { id: 2, name: "Falência" },
  { id: 3, name: "Liquidação Judicial" },
  { id: 4, name: "Insolvência Civil" },
  { id: 5, name: "Recuperação Extrajudicial" },
];

export default [...data];
